import { roundKRW } from '../constants/currencies'

// 복수 거래 항목 — 환율은 카트에 담는 시점의 값으로 고정한다.
export interface CartLine {
  currency: string
  foreignAmount: number
  krwAmount: number
  rate: number
  rateOverridden: boolean
  rateOverrideReason?: string
}

/**
 * 같은 통화와 같은 환율의 입력만 합산한다.
 *
 * 동일 통화라도 환율이 다르면 서버 거래와 영수증 항목을 분리해야 하므로
 * 별도 라인으로 유지한다. (#9)
 */
export function mergeCartLine(lines: CartLine[], line: CartLine): CartLine[] {
  const next = lines.map(item => ({ ...item }))
  const existing = next.find(item => item.currency === line.currency && item.rate === line.rate)

  if (!existing) {
    return [...next, { ...line }]
  }

  existing.foreignAmount += line.foreignAmount
  existing.krwAmount = roundKRW(existing.foreignAmount * existing.rate)
  existing.rateOverridden = existing.rateOverridden || line.rateOverridden
  existing.rateOverrideReason ||= line.rateOverrideReason
  return next
}

export function getCartLineKey(line: Pick<CartLine, 'currency' | 'rate'>): string {
  return `${line.currency}:${line.rate}`
}
